 /* eslint-enable no-unused-vars */

<template>
  <v-container bg fill-height grid-list-md text-xs-center>
    <v-layout row wrap align-center>
      <v-flex>
        <v-card>
          <v-card-title class="justify-center font-weight-bold"
            >Para firmar debes dibujar tu firma en la zona marcada</v-card-title
          >
          <v-card-text>
            <v-layout row>
              <v-flex lg6 md6 sm12 xs12 align-center>
                <esign-view-pdf
                  style="float: right;"
                  :token="$store.getters.esignToken"
                  :end-point="`${endPoint}${'getdocumentbyuuidb64/'}`"
                  :operation-uuid="$store.getters.operationUuid"
                  :document-uuid="$store.getters.documentUuid"
                  :width="500"
                  :height="710"
                  :status="0"
                  response=""
                  :loading="false"
                  :snack-bar="false"
                  success-msg="El documento ha sido descargado"
                  error-msg="Ha ocurrido un error al descargar el documento"
                ></esign-view-pdf>
              </v-flex>
              <v-flex lg6 md6 sm12 xs12 align-center>
                <esign-finger-signature
                  v-if="isVisiblePDF"
                  style="float: left;"
                  :token="$store.getters.esignToken"
                  :end-point="`${endPoint}${'addsigntodocument/'}`"
                  :operation-uuid="$store.getters.operationUuid"
                  :document-uuid="$store.getters.documentUuid"
                  sign-box-name="cajafirma1"
                  signature-points="25"
                  info-txt="Debes firmar para continuar"
                  button-clear-text="Borrar"
                  button-accept-text="Firmar "
                  :loading="false"
                  :snack-bar="false"
                  success-msg="Se ha firmado el documento"
                  error-msg="Ha ocurrido un error al firmar el documento"
                ></esign-finger-signature>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn
              class="primary"
              v-if="isButtonDocumentsVisible"
              @click="goToHome"
              >Go to home</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="isSnackBarVisible"
      :top="true"
      :color="snackBarColor"
      :right="true"
      :timeout="4000"
    >
      {{ snackBarText }}
    </v-snackbar>
  </v-container>
</template>

<script>
import EsignViewPdf from "@/components/signature/ViewPDF";
import EsignFingerSignature from "@/components/signature/FingerSignature";
export default {
  name: "handwritten",
  components: {
    EsignViewPdf,
    EsignFingerSignature,
  },
  beforeCreate() {
    window.scrollTo(0, 0);
  },
  mounted() {
    // Google Analytics
    // this.$ga.page(this.$router);
    this.EventBus.$on("successViewPDF", (event) => {
      this.isVisiblePDF = true;
    });
    this.EventBus.$on("errorViewPDF", (event) => {
      this.snackBarColor = "error";
      this.snackBarText =
        "An error occurred while downloading the document. Please refresh the page";
      this.isSnackBarVisible = true;
    });
    this.EventBus.$on("notifyViewPDF", (event) => {});
    this.EventBus.$on("successFingerSignature", (event) => {});
    this.EventBus.$on("errorFingerSignature", (event) => {
      this.snackBarColor = "error";
      this.snackBarText =
        "An error occurred signing the document. Please try again";
      this.isSnackBarVisible = true;
    });
    this.EventBus.$on("notifyFingerSignature", (event) => {});
  },
  data() {
    return {
      endPoint: process.env.VUE_APP_BASEURL,
      isVisiblePDF: false,
      snackBarColor: "",
      snackBarText: "",
      isSnackBarVisible: false,
    };
  },
  methods: {},
};
</script>

<style scoped></style>
